import { render, staticRenderFns } from "./IAP.vue?vue&type=template&id=23178e50&scoped=true&"
import script from "./IAP.vue?vue&type=script&lang=js&"
export * from "./IAP.vue?vue&type=script&lang=js&"
import style0 from "./IAP.vue?vue&type=style&index=0&id=23178e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23178e50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
